import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NavigationItem = ({ item: { link, label } }) => {
  const { t } = useTranslation('pageHeader');
  const location = useLocation();

  // Custom active logic for "/"
  const getActive = (isActive, to) => {
    if (to === '/') {
      return location.pathname.startsWith('/delivery');
    }
    return isActive;
  };

  return (
    <li className="navigation__element">
      <NavLink
        to={link}
        className={({ isActive }) =>
          getActive(isActive, link)
            ? "navigation__link navigation__link--active"
            : "navigation__link"
        }
      >
        {t(label)}
      </NavLink>
    </li>
  );
};

export default NavigationItem;
